export class UpdateCompanyStatus {
    constructor(companyRepository) {
      this.companyRepository = companyRepository;
    }
  
    async execute(company) {
      return await this.companyRepository.updateCompanyStatus(company);
    }
  }